import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import SEO from "../components/seo/SEO";
import Navigation from "../components/landing/Navigation";
import TargetAudiences from "../components/landing/TargetAudiences";
import WhyUs from "../components/landing/WhyUs";
import Process from "../components/landing/Process";
import Footer from "../components/landing/Footer";

export default function ONasPage() {
    return (
        <div className="relative bg-nova-black text-white overflow-hidden" data-testid="o-nas-page">
            <SEO
                title="O nás — KB MUSIC"
                description="Spoznajte tím KB MUSIC. Profesionálna technická produkcia eventov — od prvého kontaktu po záverečný potlesk. Skúsený tím, špičková technika."
                canonical="/o-nas"
            />
            <Navigation />

            {/* Page hero */}
            <section className="relative pt-40 pb-24 px-6 sm:px-12 overflow-hidden">
                <div className="absolute top-0 right-1/4 w-[600px] h-[600px] bg-nova-purple/10 rounded-full blur-[160px] pointer-events-none" />
                <div className="relative max-w-7xl mx-auto">
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="max-w-3xl"
                    >
                        <div className="font-mono text-xs uppercase tracking-[0.25em] text-nova-cyan mb-4">
                            / O nás
                        </div>
                        <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[1.02]">
                            Technika, ktorá{" "}
                            <span className="text-gradient">pracuje za vás</span>
                        </h1>
                        <p className="mt-6 text-zinc-400 text-lg sm:text-xl leading-relaxed max-w-2xl">
                            KB MUSIC je tím profesionálov s rokmi praxe v technickej produkcii
                            eventov na Slovensku aj v zahraničí. Postaráme sa o všetko —
                            od prvého návrhu po demontáž po skončení podujatia.
                        </p>
                        <div className="mt-10 flex flex-wrap gap-4">
                            <Link
                                to="/#contact"
                                onClick={() => setTimeout(() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }), 100)}
                                className="inline-flex items-center gap-2 h-12 px-7 rounded-md bg-nova-cyan text-black font-semibold text-sm hover:saturate-125 transition-all hover:shadow-[0_0_25px_rgba(0,153,255,0.35)]"
                            >
                                Kontaktujte nás
                                <ArrowRight className="w-4 h-4" />
                            </Link>
                            <Link
                                to="/referencie"
                                className="inline-flex items-center gap-2 h-12 px-7 rounded-md border border-white/15 text-white text-sm font-medium hover:border-white/30 hover:bg-white/5 transition-all"
                            >
                                Pozrieť referencie
                            </Link>
                        </div>
                    </motion.div>
                </div>
            </section>

            <TargetAudiences />
            <WhyUs />
            <Process />

            <Footer />
        </div>
    );
}
